module.exports = __webpack_public_path__ + "static/yuja-wang.f5bce5e3.webp";


//////////////////
// WEBPACK FOOTER
// /tmp/build_83f21ab6/src/assets/images/reviews/yuja-wang.webp
// module id = 1212
// module chunks = 0 1 2 3